import { MapPinIcon } from '@heroicons/react/24/solid'

import { CartPage } from './types/query'

type Props = {
  cart: CartPage['currentCart']
}

export default function TruckInfo({ cart }: Props) {
  return (
    <div className="mb-4 bg-blue-50 border border-solid border-blue-100 p-4 rounded-lg">
      <div className="w-full flex items-center justify-between space-x-6">
        <div className="flex-1 truncate">
          <div className="flex flex-col-reverse md:flex-row items-start md:items-center md:space-x-3 gap-y-2 md:gap-y-0">
            <h3 className="text-blue-800 font-bold text-lg truncate">
              {cart!.location!.truck?.name}
            </h3>
            <div className="shrink-0 flex px-4 py-1 text-orange-800 font-medium bg-orange-200 underline rounded-full">
              <MapPinIcon className="h-5 w-5 text-orange-600 text-sm mr-2" />
              {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
              <a
                className="text-sm"
                href={encodeURI(
                  `https://www.google.com/maps/place/${
                    cart!.location!.lot.fullAddress
                  }`
                )}
                rel="noreferrer"
                target="_blank"
              >
                {cart!.location!.lot!.address}
              </a>
            </div>
          </div>
          <p className="mt-1 text-gray-700 text-sm truncate">
            {cart!.location?.lot.name}
          </p>
        </div>
      </div>
    </div>
  )
}
